const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Rashika Sehgal</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Design Head, UPES-CSI</li>
    <li>
        Leading design strategy and creative direction.
    </li>
    <li>
        Crafting visual identity for CSI.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
